/** @format */
import {ReactNode} from 'react';

import {ExpandIcon} from '@storybook/icons';

import {Box} from '@mui/material';

import {BgImage, SetupButton, SubHeaderChip} from '../../styles';
import {HotspotVariant, HotspotSmallFullness} from '../../types';
import {
  ButtonsBox,
  Content,
  HeaderText,
  ExpandButton,
  Root,
  HeaderWithIcon,
  Header,
  HelpButton,
  BigReadyButton,
  TooltipPaper,
} from './styles';
import {HintIconTooltip} from '../../../../../HintIconTooltip';

interface Props {
  variant: HotspotVariant;
  bgImage: string;
  onExpand: () => void;
  onSetup: () => void;
  fullness: HotspotSmallFullness;
  isReady: boolean;
  bgOpacity: number;
  content: {
    headerText: string;
    HeaderIcon?: ReactNode;
    subHeaderText?: string;
    HelpComponent: ReactNode;
    buttonText: string;
  };
}

const HotspotSmall = ({
  variant,
  bgImage,
  content,
  onSetup,
  onExpand,
  isReady,
  fullness,
  bgOpacity,
}: Props) => {
  const {headerText, subHeaderText, HeaderIcon, HelpComponent, buttonText} = content;
  const isCompact = fullness === 'compact';

  const isRenderHeaderChip = !isCompact && subHeaderText && !isReady;
  const isRenderBigButton = isReady && isCompact;

  return (
    <Root isCompact={isCompact}>
      {isRenderBigButton ? (
        <BigReadyButton onClick={onSetup}>
          {HeaderIcon}
          <HeaderText>{headerText}</HeaderText>
        </BigReadyButton>
      ) : (
        <Content>
          <Header>
            <HeaderWithIcon>
              {HeaderIcon}
              <HeaderText>{headerText}</HeaderText>
            </HeaderWithIcon>
            {isRenderHeaderChip ? (
              <SubHeaderChip>{subHeaderText}</SubHeaderChip>
            ) : isCompact ? null : (
              <Box />
            )}
          </Header>

          <ButtonsBox>
            {!isReady && (
              <ExpandButton onClick={onExpand}>
                <ExpandIcon />
              </ExpandButton>
            )}
            <SetupButton onClick={onSetup} customVariant={variant}>
              {isReady ? 'Редактировать' : buttonText}
            </SetupButton>
          </ButtonsBox>
        </Content>
      )}

      {!isCompact && <BgImage src={bgImage} alt='' sx={{opacity: bgOpacity}} />}

      <HelpButton>
        <HintIconTooltip title={<TooltipPaper>{HelpComponent}</TooltipPaper>} />
      </HelpButton>
    </Root>
  );
};

export {HotspotSmall};
